import { DomainCheckResults } from '@/core/ryanada'
import { DomainViewModel } from '@/view-models'
import { BulkDomainSearchDomainResultView } from './domain-result.view'

export class BulkDomainSearchDomainResultListView {
  private el: HTMLElement
  private readonly viewModel: DomainViewModel
  private readonly TOKEN: string

  constructor(el: HTMLElement, viewModel: DomainViewModel, token: string) {
    // Assign
    this.el = el
    this.viewModel = viewModel
    this.TOKEN = token
  }

  private getTldTemplate(): HTMLElement {
    const template = this.el.querySelector<HTMLElement>(
      '.js-domain-search__bulk-result:not(.clone)'
    )

    if (!template) {
      throw new Error(
        'BulkDomainSearchDomainResultListView: Domain Result Template is null'
      )
    }

    const clone = <HTMLAnchorElement>template.cloneNode(true)

    // Mark as clone
    clone.classList.add('clone')

    // Remove display none
    clone.style.display = 'block'

    return clone
  }

  private getWrapperElement(): Element {
    const resultsWrapper = this.el.closest('.js-domain-search__bulk-results')

    if (!resultsWrapper) {
      throw new Error(
        'BulkDomainSearchDomainResultListView: .js-domain-search__bulk-results is not defined'
      )
    }

    return resultsWrapper
  }

  public show(): void {
    const resultsWrapper = this.getWrapperElement()
    resultsWrapper.classList.remove('hidden')
  }

  public hide(): void {
    const resultsWrapper = this.getWrapperElement()
    resultsWrapper.classList.add('hidden')
  }

  private clearList(): void {
    const domainsToDelete = this.el.querySelectorAll<HTMLAnchorElement>(
      '.js-domain-search__bulk-result:is(.clone)'
    )

    domainsToDelete.forEach((domainEl) => {
      this.el.removeChild(domainEl)
    })
  }

  public appendDomains(domains: DomainCheckResults[]): void {
    this.clearList()

    domains.forEach((domain) => {
      const template = this.getTldTemplate()
      new BulkDomainSearchDomainResultView(
        template,
        domain,
        this.viewModel,
        this.TOKEN
      )
      this.el.append(template)
    })
  }
}
